import axios from 'axios';
import { utilityService } from '@/services/utilityService.js';
import { authTokenService } from '@/services/authTokenService.js';

/**
 * Runs all validations for the currently active survey.
 */
function __runValidationForSurvey () {
	let surveyId = authTokenService.getActiveSurveyId();
	return axios.post(utilityService.getApiUrl(`validation/${surveyId}`),
		{},
		// Third parameter is the configuration object
		{
				headers: utilityService.getHeaders()
		}
	);
}

/**
 * Runs the validations for the specified question of the currently active survey.
 * @param {int} questionId The question id
 */
function __runValidationForQuestion (questionId) {
		let surveyId = authTokenService.getActiveSurveyId();
		return axios.get(utilityService.getApiUrl(`validation/${surveyId}/question/${questionId}`),
			// Third parameter is the configuration object
			{
					headers: utilityService.getHeaders()
			}
    );
}

/**
 * Gets the validations for the survey. Does not rerun the validations.
 */
function __getValidationMessagesForSurvey () {
	let surveyId = authTokenService.getActiveSurveyId();
	return axios.get(utilityService.getApiUrl(`validation/${surveyId}`),
		// Third parameter is the configuration object
		{
				headers: utilityService.getHeaders()
		}
	);
}

/**
 * Updates isDismissed flag for given messages.
 */
function __updateDismissedWarnings (dismissRequest) {
	return axios.post(utilityService.getApiUrl(`validation/message`),
		dismissRequest,
		{
				headers: utilityService.getHeaders()
		}
  );
}

export const errorService = {
		getValidationMessagesForQuestion: (questionId) => __runValidationForQuestion(questionId),
		getValidationMessagesForSurvey: () => __getValidationMessagesForSurvey(),
		runValidationForQuestion: (questionId) => __runValidationForQuestion(questionId),
    runValidationForSurvey: () => __runValidationForSurvey(),
		updateDismissedWarnings: (dismissRequest) => __updateDismissedWarnings(dismissRequest)
};
